import { EmployeeHelper } from "@/Common/Helpers/EmployeeHelper";
import { SiteUIModel } from "@/Common/Models/Sites/SiteUIModel";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { CommunicationsHelper } from "@/Communications/Helpers/CommunicationsHelper";

interface ICommunicationShareableSettings {
    IsAllSitesChecked: boolean;
    IsAllCliniciansChecked: boolean;
    IsAllPriorityChecked: boolean;
    ClinicianIds: string[];
    Priorities: string[];
    PageSize: number;
    SiteIds: string[];
    OrderByPriorityFirst: boolean;
}

abstract class BaseCommunicationSettingsState {
    public isAllSitesChecked: boolean;
    public isAllCliniciansChecked: boolean;
    public isAllPrioritiesChecked: boolean;
    public isSaveSettingChecked: boolean;
    public cliniciansSearchText: string;
    public priorities: CheckboxUIModel[];
    public pageSizeOptions: number[];
    public selectedPageSizeOption: number;
    public dateFrom: Date;
    public dateTo: Date;
    public sites: SiteUIModel[];
    public clinicians: EmployeeUIModel[];
    public employeesGlobalCache: EmployeeUIModel[];
    public orderByPriorityFirst: boolean;

    public setBaseDefault(defaultCliniciansCheckedIds?: string[]): void {
        this.isAllSitesChecked = false;
        this.isAllCliniciansChecked = false;
        this.isAllPrioritiesChecked = false;
        this.isSaveSettingChecked = false;
        this.pageSizeOptions = [50, 100, 150];
        this.selectedPageSizeOption = 50;
        this.cliniciansSearchText = "";
        this.sites = cacheStore.GetSites(CheckboxTarget.Myle_Communications_Recalls_Search_Site);
        this.sites.forEach(site => site.Checked = true);

        this.priorities = CommunicationsHelper.GetCommunicationPrioritiesCheckboxesFromCache("TaskPrority", CheckboxTarget.Myle_Communications_Messages_Search_Priority);

        this.employeesGlobalCache = cacheStore.GetCliniciansAsEmployees(CheckboxTarget.Myle_Communications_Messages_Search_Clinician, true);
        this.clinicians = this.employeesGlobalCache;
        if (!isArrayNullOrUndefinedOrEmpty(defaultCliniciansCheckedIds)) {
            this.clinicians.forEach(x => x.Checked = defaultCliniciansCheckedIds.contains(x.ContactId));
        }
        this.orderByPriorityFirst = false;
    }

    public setBaseSearchSettingsFromUserPreferences(setting: ICommunicationShareableSettings): void {
        if (setting === null)
            return;

        this.isAllSitesChecked = setting.IsAllSitesChecked || this.isAllSitesChecked;
        this.isAllCliniciansChecked = setting.IsAllCliniciansChecked || this.isAllCliniciansChecked;
        this.isAllPrioritiesChecked = setting.IsAllPriorityChecked || this.isAllPrioritiesChecked;
        this.selectedPageSizeOption = setting.PageSize || this.selectedPageSizeOption;

        if (setting.ClinicianIds)
            this.clinicians.forEach(c => c.Checked = setting.ClinicianIds.contains(c.Id));

        if (setting.Priorities)
            this.priorities.forEach(c => c.Checked = setting.Priorities.contains(c.Id));

        if (setting.SiteIds && setting.SiteIds.any()) {
            this.sites.forEach(c => c.Checked = setting.SiteIds.contains(c.Id));
            this.clinicians = EmployeeHelper.filterCliniciansByCheckedSites(this.employeesGlobalCache, this.sites);
        }

        this.orderByPriorityFirst = setting.OrderByPriorityFirst;
    }
}

export { BaseCommunicationSettingsState };
